import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'one-c/',
    name: 'OneC',
    component: () => import('~/views/oneC/OneC.vue'),
    meta: {
      title: '1С',
    }
  },
  // {START} lists
  {
    path: 'one-c/bases',
    name: 'OneC.Bases',
    component: () => import('~/views/oneC/lists/BasesOneC.vue'),
    meta: {
      title: 'Список информационных баз 1С',
    }
  },
  {
    path: 'one-c/bases/detail/:id?',
    name: 'OneC.Base',
    component: () => import('~/views/oneC/list-items/BaseOneC.vue'),
    meta: {
      title: 'Информационная база 1С',
    }
  },
  {
    path: 'one-c/archives',
    name: 'OneC.Archives',
    component: () => import('~/views/oneC/lists/ArchivesOneC.vue'),
    meta: {
      title: 'Архив информационных баз 1С',
    }
  },
  {
    path: 'one-c/users',
    name: 'OneC.Users',
    component: () => import('~/views/oneC/lists/UsersOneC.vue'),
    meta: {
      title: 'Список пользователей',
    }
  },
  {
    path: 'one-c/profiles',
    name: 'OneC.Profiles',
    component: () => import('~/views/oneC/lists/ProfilesOneC.vue'),
    meta: {
      title: 'Профили пользователей',
    }
  },
  {
    path: 'one-c/profiles/detail/:id?',
    name: 'OneC.Profile',
    component: () => import('~/views/oneC/list-items/ProfileOneC.vue'),
    meta: {
      title: 'Профиль пользователя',
    }
  },
  {
    path: 'one-c/users-access',
    name: 'OneC.UsersAccess',
    component: () => import('~/views/oneC/lists/UsersAccess.vue'),
    meta: {
      title: 'Доступы пользователей в базы 1С',
    }
  },
  {
    path: 'one-c/users-access/detail/:id?',
    name: 'OneC.UserAccess',
    component: () => import('~/views/oneC/list-items/UserAccess.vue'),
    meta: {
      title: 'Доступ пользователя в базу 1С',
    }
  },
  {
    path: 'one-c/contracts',
    name: 'OneC.Contracts',
    component: () => import('~/views/oneC/lists/ContractsOneC.vue'),
    meta: {
      title: 'Договоры',
    }
  },
  {
    path: 'one-c/bills',
    name: 'OneC.Bills',
    component: () => import('~/views/oneC/lists/BillsOneC.vue'),
    meta: {
      title: 'Счета на оплату',
    }
  },
  {
    path: 'one-c/payments',
    name: 'OneC.Payments',
    component: () => import('~/views/oneC/lists/PaymentsOneC.vue'),
    meta: {
      title: 'Оплаты',
    }
  },
  {
    path: 'one-c/acts',
    name: 'OneC.Acts',
    component: () => import('~/views/oneC/lists/ActsOneC.vue'),
    meta: {
      title: 'Акты оказанных услуг',
    }
  },
  // {END} lists
];